import React from "react";
import StaffDashboard from "./StaffDashboard";
import StaffMasterDashboard from "./StaffMasterDashboard";
import { Accordion } from "react-bootstrap";

function RegistrarDashboardTab() {
  return (
    <>
      <Accordion key={"0"} defaultActiveKey={"0"}>
        <Accordion.Item eventKey="0">
          <Accordion.Header>สรุปจดทะเบียนชาวไร่อ้อย</Accordion.Header>
          <Accordion.Body>
            <StaffDashboard />
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
      <Accordion key={"1"} defaultActiveKey={"1"}>
        <Accordion.Item eventKey="1">
          <Accordion.Header>สรุปจดหัวหน้ากลุ่มชาวไร่อ้อย</Accordion.Header>
          <Accordion.Body>
            <StaffMasterDashboard />
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </>
  );
}

export default RegistrarDashboardTab;
